import { Component } from 'react';
import { connect } from 'react-redux';
import BrandCarouselItem from './brand-carousel-item';
import CarouselRender from './carousel-render';
import BrandBanner from './brand-banner';

class BluBarCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      activeBannerBrandId: 0
    };
  }

  render() {
    const {
      loading,
      bluBarBrands
    } = this.props;
    const { isScrolled, activeBannerBrandId } = this.state;
    const bluBarBrandBanner = +activeBannerBrandId === 0 ?
      bluBarBrands[0] :
      bluBarBrands.find(brand => (+brand.id === +activeBannerBrandId));
    const isMobileScreen = window.innerWidth <= 768;

    const data = bluBarBrands.map((bluBarBrand, i) => (
      bluBarBrand.attributes.products.map((product, j) => (
        <div
          key={`${i}${j}`}
          onMouseEnter={() => {
            this.setState({ activeBannerBrandId: bluBarBrand.id });
          }}
        >
          <BrandCarouselItem
            key={`${i}${j}`}
            image={product.photo}
            id={product.id}
            name={bluBarBrand.attributes.name}
            isScrolled={isScrolled}
          />
        </div>
      ))
    )).flat();

    return (
      <div className="brand-carousel-container">
        {data.length !== 0 && (
          <div className="user-inner-container">
            <h2>Our Next Generation Product Range</h2>
          </div>
        )}
        {bluBarBrandBanner && !isMobileScreen &&
          <BrandBanner links={bluBarBrandBanner.links} attributes={bluBarBrandBanner.attributes} />}
        <CarouselRender loading={loading} data={data} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.brandsUser.fetching,
  bluBarBrands: state.brandsUser.bluBarBrands
});

export default connect(mapStateToProps)(BluBarCarousel);
